module.exports = __webpack_public_path__ + "static/image/history/pc/201501.jpg?dd6a900d";